import { Skeleton } from "@/shared/components/ui/skeleton";
import { HTMLAttributes } from "react";
import { useHtzAirHandlingUnitShowQuery } from "@/services/backend/htz/ahu/api/ahu-api";

export function AhuName({
  className,
  airHandlingUnitId,
  ...props
}: { airHandlingUnitId: string } & HTMLAttributes<HTMLSpanElement>) {
  const { data } = useHtzAirHandlingUnitShowQuery({ id: airHandlingUnitId });
  return (
    <span className={className} {...props}>
      {data?.name || <Skeleton className="inline-flex h-4 w-24" />}
    </span>
  );
}
